// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.info-box[data-v-00eb762c]{\n\tbackground: var(--main-light-blue); padding: 4px 12px; border:1px solid var(--main-blue-1) ; border-radius: 4px;\n\tcolor: var(--main-blue-3);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
